import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchCartItems } from '../../actions'
import ContentLoader from '../global/loaders/ContentLoader'

const CheckoutRedirectHandler = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const result = await dispatch(fetchCartItems())

        if (result?.cart_items?.length > 0 && result?.short_code) {
          history.replace(`/cart/${result.short_code}`)
        } else {
          history.replace('/cart')
        }
      } catch (error) {
        history.replace('/cart')
      }
    }
    handleRedirect()
  }, [])

  return <ContentLoader />
}

export default CheckoutRedirectHandler
